module.exports = __webpack_public_path__ + "img/Character_Kuki_Shinobu_Thumb.6f2c3f11.png";